import { createReducer } from '../../utils';
import types from './types';

export const initialState = {
    loading: false,
    country: null,
};

const SYNC_ACTION_HANDLERS = {
    [types.SET_COUNTRY]: (state, { payload: { country } }) => ({
        ...state,
        loading: false,
        country
    })
};

const ASYNC_ACTION_HANDLERS = {
    [types.SAVE_COUNTRY.REQUEST]: state => ({
        ...state,
        loading: true
    }),
    [types.SAVE_COUNTRY.SUCCESS]: (state, { payload: { country } }) => ({
        ...state,
        loading: false,
        country
    }),
    [types.SAVE_COUNTRY.ERROR]: state => ({
        ...state,
        loading: false,
        country: null
    })
};

const ACTION_HANDLERS = {
    ...SYNC_ACTION_HANDLERS,
    ...ASYNC_ACTION_HANDLERS
};

export default createReducer(ACTION_HANDLERS, initialState);
